import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'cert-qualification-path-badge',
  template: `
    <div class="flex-wrap d-flex align-center gap-1">
      <span *ngFor="let path of qualificationPaths" class="badge bg-info" [title]="path">
        {{ path }}
      </span>
    </div>
  `,
  styles: ``,
  standalone: false,
})
export class QualificationPathBadgeComponent implements ICellRendererAngularComp {
  public qualificationPaths: string[] = [];

  agInit(params: ICellRendererParams): void {
    if (params.value) {
      this.qualificationPaths = Array.isArray(params.value) ? params.value : [params.value];
    }
  }

  refresh(params: ICellRendererParams): boolean {
    this.agInit(params);
    return true;
  }
}
